
import {
  defineComponent, ref, watch, reactive, onMounted, inject, readonly,
} from 'vue';
import { useStore, } from 'vuex';
import {
  Tree, Checkbox,Button, message,
} from 'ant-design-vue';
// 权限管理除最低一级菜单外其他节点id（控制tree不被全选）
import { otherAuthorityIds, otherDataIds,otherAuthorityAppIds, } from '../../configs/index';
import { getRightLists, } from './authorityReq';
import { postRequest, } from '@/request/request';
import { defaultMenuIds, } from '@/configs/defaultMenu.config';

const store = useStore();

export default defineComponent({
  components: { Tree, Checkbox, },
  props: {
    requestType: {
      type: String,
      default: 'role',
      require: true,
    },
    roleId: {
      type: String,
      default: '',
      require: true,
    },
    readonly: {
      type: Boolean,
      default: () => false,
      require: false,
    },
    showTicketConfig: {
      type: Boolean,
      default: () => false,
      require: false,
    },
    roleData: {
      type: String,
      default: '',
      require: true,
    },
    disabledTicketConfig: {
      type: Boolean,
      default: () => false,
      require: false,
    },
    modalType: {
      type: String,
      default: () => '',
      require: false,
    },
  },
  setup (props,{ emit, }) {
    // 移动端权限必选菜单
    const mustMenuIds = ['200102',
      '200201',
      '200301',
      '200402',];
    // 当前选中的必选菜单
    const selectedMustIds = ref<string[]>([]);
    const itemInfo: any = inject('itemInfo');
    const tabButton = ref<any>({
      pc: 'PC端',
      mobile: '移动端',
    });
    const selectTab = ref<any>('pc');
    const terminals = reactive<Array<any>>([
      {
        value: 'pc',label: 'PC端', checked: false,disabled: true,
      },
      {
        value: 'mobile',label: '移动端', checked: false, disabled: false,
      },
    ]);

    // 所有权限的key

    // const allKeys: any[] = [];

    // 获取的菜单数据
    const allMenuList = ref<any[]>([]);
    // 左侧列表权限
    const leftTreeGrant = ref<any[]>([]);
    // 左侧列表展开节点
    const leftExpandData = ref<any[]>([]);
    // 移动端列表权限
    const appTreeGrant = ref<any[]>([]);
    const appCheckedKeys = ref<any[]>([]);
    const appHalfCheckedKeys = ref<any[]>([]);
    const appExpandData = ref<any[]>([]);
    // 右侧列表权限
    const rightTreeGrant = ref<any[]>([]);
    // 右侧列展开节点
    const rightExpandData = ref<any[]>([]);
    // 左侧选中的节点（控制最低一级菜单）
    const leftCheckedKeys = ref<any[]>([]);
    // 左侧半选中的节点
    const leftHalfCheckedKeys = ref<any[]>([]);
    // 右侧选中的节点
    const rightCheckedKeys = ref<any[]>([]);
    // 右侧半选中的节点
    const rightHalfCheckedKeys = ref<any[]>([]);
    const radioCheck = ref<string>('disable');
    const disabled = ref<boolean>(true);
    const readonlyStyle = ref<string>('');
    // 应用系统是否选择了移动端
    const checkMobile = ref<boolean>(false);

    const clickTabButton = (val: string) => {
      selectTab.value = val;
    };

    const dealChildren = (data: any): Array<any> => {
      const temp: Array<any> = [];

      data.forEach((item: any) => {
        temp.push(item.children ?
          {
            key: item?.id,
            title: item?.name,
            ...item,
            slots: {
              icon: item?.useTo === '0' ? 'buttonIcon' : '',
            },
            children: dealChildren(item?.children),
          } :
          {
            key: item?.id,
            title: item?.name,
            slots: {
              icon: item?.useTo === '0' ? 'buttonIcon' : '',
            },
            ...item,
          });
      });

      return temp;
    };

    const dealFlat = (data: any): Array<any> => {
      const temp: Array<any> = [];

      data.forEach((item: any) => {
        temp.push(item.id);

        if (item.children) {
          temp.push(dealFlat(item.children));
        }
      });

      return temp;
    };

    // 计算树形结构的展开节点
    const computeExpandKeys = (data: any,depth:number) => {
      if (depth < 1 || !data || !data.length) {
        return [];
      }

      const temp: Array<any> = [];

      data.forEach((item: any) => {
        temp.push(item.id);
        temp.push(...computeExpandKeys(item.children,depth - 1));
      });

      return temp;
    };

    const handleCheck = (selectedKeys: any,e:any, type: string): void => {
      const { checked, } = e;

      // 选中必选菜单时加入必选数组
      if (checked) {
        selectedKeys.forEach((key: any) => {
          if (mustMenuIds.includes(key) && !selectedMustIds.value.includes(key)) {
            selectedMustIds.value.push(key);
          }
        });
      }

      if (type === 'pc') {
        leftCheckedKeys.value = selectedKeys;
        leftHalfCheckedKeys.value = e.halfCheckedKeys;
      } else if (type === 'app') {
        // eslint-disable-next-line lines-around-comment
        /*
         * 数组并集
         * app端需求：必选菜单不可取消，同时祖先节点保持半选/全选状态
         * 使用disbaled属性控制必选菜单不可取消会导致祖先节点没有半选状态，所以采用每次check时加入selectedMustIds必选菜单id的方式
         */
        const temp = [...selectedKeys,...selectedMustIds.value,].filter((v, i, arr) => arr.indexOf(v) === i);

        appCheckedKeys.value = temp;
        appHalfCheckedKeys.value = e.halfCheckedKeys;
      } else {
        rightCheckedKeys.value = selectedKeys;
        rightHalfCheckedKeys.value = e.halfCheckedKeys;
      }
      if (checkMobile.value || leftCheckedKeys.value.includes('1004001') || leftCheckedKeys.value.includes('1004002') || rightCheckedKeys.value.includes('2')) {
        // radioCheck.value = 'personalData';
        disabled.value = false;
      } else {
        // radioCheck.value = 'disable';
        disabled.value = true;
      }

      if (leftCheckedKeys.value && leftCheckedKeys.value.length) {
        terminals[0].checked = true;
        emit('checkedTerminal', true);
      } else {
        terminals[0].checked = false;
        emit('checkedTerminal', false);
      }
    };

    const handleExpand = (keys: any, type: string):void => {
      if (type === 'pc') {
        leftExpandData.value = keys;
      } else if (type === 'app') {
        appExpandData.value = keys;
      } else {
        rightExpandData.value = keys;
      }
    };

    const initSeleted = (right:string[]) => {
      if (!right) return;

      // 保存已选三级菜单key
      leftCheckedKeys.value = right.filter((cur: any) => cur.indexOf('1') === 0 && otherAuthorityIds.indexOf(cur) === -1);
      appCheckedKeys.value = right.filter((cur: any) => cur.indexOf('2') === 0 && otherAuthorityAppIds.indexOf(cur) === -1);
      selectedMustIds.value = right.filter((cur: any) => mustMenuIds.indexOf(cur) > -1);
      // 保存半选二级菜单状态key留用
      leftHalfCheckedKeys.value = right.filter((cur: any) => otherAuthorityIds.indexOf(cur) > -1);
      appHalfCheckedKeys.value = right.filter((cur: any) => otherAuthorityAppIds.indexOf(cur) > -1);
      rightCheckedKeys.value = right.filter((cur: any) => cur.indexOf('4') === 0 && otherDataIds.indexOf(cur) === -1);
      rightHalfCheckedKeys.value = right.filter((cur: any) => otherDataIds.indexOf(cur) > -1);

      const checkedPC = right.filter((cur: any) => cur === '1');

      checkMobile.value = right.findIndex((cur: any) => cur === '5') > -1;

      /*
       * if (checkedPC.length) {
       *   terminals[0].checked = true;
       * }
       * if (checkedMobile.length) {
       *   terminals[1].checked = true;
       * }
       */

      if (checkMobile.value || leftCheckedKeys.value.includes('1004001') || leftCheckedKeys.value.includes('1004002') || rightCheckedKeys.value.includes('2')) {
        radioCheck.value = props.roleData || '';
        disabled.value = !!props.disabledTicketConfig;
      } else {
        disabled.value = true;
      }

      terminals[0].checked = !!right.includes('1');
      terminals[1].checked = !!right.includes('5');
    };

    const constructMenuTree = (data:any) => {
      // 初始化选择
      initSeleted(itemInfo.value.menuIds);

      // 数据列表
      const dataList = data?.data || [];
      const rightDealData = dealChildren(dataList);

      rightTreeGrant.value = rightDealData;
      // 右侧展开一级菜单

      rightExpandData.value = computeExpandKeys(dataList,1);
      // 菜单/功能列表
      const menuList = data?.menu || [];

      if (!menuList.length) return;
      const leftDealData = dealChildren(menuList);

      // leftTreeGrant.value.push(selectTab.value === 'pc' ? leftDealData[0] : leftDealData[1]);
      leftTreeGrant.value = leftDealData[0] ? [leftDealData[0],] : [];
      appTreeGrant.value = leftDealData[1] ? [leftDealData[1],] : [];
      // 左侧展开前两级菜单
      leftExpandData.value = computeExpandKeys(leftTreeGrant.value,2);
      //  leftExpandData.value = dealFlat(menuList).flat(Infinity);

      appExpandData.value = computeExpandKeys(appTreeGrant.value,2);
    };

    const getTerminalSelected = () => {
      const isSelected:any = [];

      terminals.forEach((item:any) => {
        if (item.checked) {
          isSelected.push(item.value);
        }
      });

      return isSelected;
    };

    const getTicketRadioChecked = () => {
      let flag = true;
      const selectTicketMenu = leftCheckedKeys.value.includes('1004001') || leftCheckedKeys.value.includes('1004002');
      const ticketRadioChecked = radioCheck.value === 'allData' || radioCheck.value === 'personalData';

      if (selectTicketMenu) {
        flag = ticketRadioChecked;
      }

      if (checkMobile.value) {
        flag = ticketRadioChecked;
      }

      return flag;
    };

    const terminalsCheckedChange = () => {
      const flag = terminals.findIndex((item:any) => item.value === 'mobile' && item.checked) > -1 || leftCheckedKeys.value?.length > 0;

      checkMobile.value = terminals.findIndex((item:any) => item.value === 'mobile' && item.checked) > -1;

      if (checkMobile.value || leftCheckedKeys.value.includes('1004001') || leftCheckedKeys.value.includes('1004002') || rightCheckedKeys.value.includes('2')) {
        disabled.value = false;
      } else {
        disabled.value = true;
      }

      emit('change', flag);
    };

    const getDataAndInit = () => {
      let url = '';

      switch (props.requestType) {
      case 'super':
        url = '/menu/menuAllList';
        getRightLists(url).then(({ data, }:any) => {
          allMenuList.value = data;
          constructMenuTree(data);
        });
        break;
      case 'own':
        postRequest('/role/roleMenuTree',{ roleId: itemInfo.value.roleId, }).then(({ data, }:any) => {
          allMenuList.value = data;
          constructMenuTree(data);
        });
        break;
      default:
        url = '/menu/menuList';
        getRightLists(url).then(({ data, }:any) => {
          allMenuList.value = data;
          constructMenuTree(data);
        });
        break;
      }
    };

    // 根据选中id,递归查找所有节点(包括半选节点)
    const findAllKeys = (tree:any, selectedIds:string[]) => {
      const result = new Set();

      const traverse = (node:any, path = [] as string[]) => {
        if (selectedIds.includes(node.id)) {
          path.forEach((ancestor) => result.add(ancestor));
          result.add(node.id);
        }
        if (node.children) {
          node.children.forEach((child:any) => traverse(child, [...path, node.id,]));
        }
      };

      tree.forEach((node:any) => traverse(node));

      return Array.from(result);
    };

    const getCurRights = () :any => {
      const { roleId, } = itemInfo.value;
      const temp: any = [...leftCheckedKeys.value, ...leftHalfCheckedKeys.value,];
      const appKeys = findAllKeys(appTreeGrant.value,appCheckedKeys.value);

      const params = {
        roleId,
        menuIds: [...temp,
          ...appKeys,
          ...rightCheckedKeys.value,
          ...rightHalfCheckedKeys.value,],
        dataType: radioCheck.value,
      };

      const terminalSelected:any = getTerminalSelected();

      if (terminalSelected) {
        terminalSelected.forEach((type:string) => {
          if (type === 'pc' && params.menuIds.indexOf('1') === -1) {
            params.menuIds.push('1');
          }
          if (type === 'mobile' && params.menuIds.indexOf('5') === -1) {
            params.menuIds.push('5');
          }
        });
      }

      if (terminals[0].checked && params.menuIds.indexOf('1') === -1) {
        params.menuIds.push('1');
      }

      if ((rightCheckedKeys.value?.length || rightHalfCheckedKeys.value?.length) && params.menuIds.filter((id:string) => id === '4').length === 0) {
        params.menuIds.push('4');
      }

      return params;
    };

    watch(() => selectTab.value,(type:string) => {
      // constructMenuTree(allMenuList.value);

      /*
       * if (type === 'mobile') {
       *   const menuList = allMenuList.value?.menu || [];
       */

      /*
       *   leftCheckedKeys.value = [];
       *   leftExpandData.value = [];
       *   const leftDealData = dealChildren(menuList);
       */

      /*
       *   leftTreeGrant.value = [];
       *   leftTreeGrant.value.push(leftDealData[1]);
       * } else {
       *   constructMenuTree(allMenuList.value);
       * }
       */
    });

    watch([leftCheckedKeys,], ([pcVal,]) => {
      if (pcVal.length || terminals.findIndex((item:any) => item.value === 'mobile' && item.checked) > -1) {
        emit('change', true);
      } else {
        emit('change', false);
      }
    });

    watch(() => props.readonly,(flag:boolean) => {
      if (flag) {
        terminals[1].disabled = true;
        readonlyStyle.value = 'height:5.3rem';
      }
    },{
      immediate: true,
    });

    // 新建admin、试用账号时，权限勾选默认菜单
    watch(() => props.modalType,(type:string) => {
      if (type === 'add') {
        setTimeout(() => {
          initSeleted(defaultMenuIds);
        },500);
      }
    },{
      immediate: true,
    });

    onMounted(() => {
      getDataAndInit();
    });

    return {
      tabButton,
      selectTab,
      terminals,
      //   allKeys,
      leftTreeGrant,
      leftExpandData,
      rightTreeGrant,
      rightExpandData,
      leftCheckedKeys,
      leftHalfCheckedKeys,
      rightCheckedKeys,
      rightHalfCheckedKeys,
      radioCheck,
      disabled,
      readonlyStyle,
      appTreeGrant,
      appCheckedKeys,
      appExpandData,

      clickTabButton,
      handleCheck,
      handleExpand,
      getTerminalSelected,
      getCurRights,
      terminalsCheckedChange,
      initSeleted,
      getTicketRadioChecked,
      selectedMustIds,
    };
  },
});

